"use client";

import { useMemo } from "react";
import { sanitizeCmsHtml } from "@/lib/sanitize/cms-html";
import type { VisualCmsSection } from "@/types/visual-cms";
import { SECTION_CONTAINER, sectionShellStyle } from "./section-shell";

interface RichTextSectionProps {
  section: VisualCmsSection;
}

function readString(c: Record<string, unknown>, key: string): string {
  const v = c[key];
  return typeof v === "string" ? v : "";
}

export function RichTextSection({ section }: RichTextSectionProps) {
  const content = (section.content as Record<string, unknown>) ?? {};
  const html = readString(content, "html");
  const shell = sectionShellStyle(section);

  const sanitized = useMemo(() => (html ? sanitizeCmsHtml(html) : ""), [html]);

  return (
    <section className={shell.className} style={shell.style}>
      <div className={SECTION_CONTAINER}>
        {sanitized ? (
          <article
            className="prose prose-lg max-w-3xl mx-auto prose-headings:font-bold prose-a:text-green-700 prose-img:rounded-lg"
            dangerouslySetInnerHTML={{ __html: sanitized }}
          />
        ) : (
          <div className="max-w-3xl mx-auto rounded-lg border border-dashed border-gray-300 px-6 py-10 text-center text-sm text-current/60">
            Rich text section — no content yet.
          </div>
        )}
      </div>
    </section>
  );
}
